// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 13C2 11.343 3.12378 9.81486 4.7012 9.32086C4.7004 9.28066 4.7 9.24037 4.7 9.2C4.7 5.7406 7.60128 3 11.1 3C11.646 3 12.1775 3.06644 12.6858 3.192C14.8331 3.7225 16.5652 5.31155 17.2193 7.37863C17.9416 7.47026 18.6217 7.69802 19.2299 8.03569C20.9409 8.9857 22 11.0856 22 13C13.7464 13 5.87993 13 2 13ZM2 15H8V17H2V15ZM10 15H22V17H10V15ZM17 19H22V21H17V19ZM2 21L2 19L15 19V21L2 21Z"}}]};

const FogFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fog-filled',
    ref,
    icon: element,
  },
));

FogFilledIcon.displayName = 'FogFilledIcon';

export default FogFilledIcon;
